import React from "react";
import autoBind from "react-autobind";
import Field from "../../../components/Field";
// import FieldLocation from '../../../components/FieldLocation'
import {pointInstructions} from "../../../strings/en-us/text";
import {InstructionsContainer} from "../../../components/Instructions";
import {PanelContainer, Panel} from "../../../components/Panel";
import noty from "../../../lib/noty";
import {MapPortal} from "../../../components/Map";
import MapEditPoint from "../MapEditPoint";

export default class EditBuilding extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      panelOpen: true,
      fetching: false,
      touched: false,
      building: this.props.building
    };
  }

  handlePanelToggle() {
    this.setState({panelOpen: !this.state.panelOpen});
  }

  handleChange({name, value}) {
    const path = name.split(".");
    this.setState({
      touched: true,
      building: this.state.building.setIn(path, value)
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const {building} = this.state;
    this.setState({fetching: true});
    building
      .patch()
      .then(patched => {
        this.setState({fetching: false, touched: false});
        noty.success("Building updated.");
      })
      .catch(err => {
        this.setState({fetching: false});
        noty.errors(err);
      });
  }

  handleRemove() {
    const {building} = this.state;
    noty.confirm(`Are you sure you want to delete "${building.name}"`, {
      onOk: () => {
        this.setState({fetching: true});
        building
          .remove()
          .then(removed => {
            noty.success("Building removed.");
          })
          .catch(err => {
            this.setState({fetching: false});
            noty.errors(err);
          });
      }
    });
  }

  render() {
    const {building, touched, fetching} = this.state;
    return (
      <div>
        <PanelContainer width={475} open={this.state.panelOpen} onToggle={this.handlePanelToggle}>
          <Panel
            onSaveClick={this.handleSubmit}
            saveTitle="Save Building"
            onDeleteClick={this.handleRemove}
            // onCopyClick={this.handleRemove}
            fetching={fetching}
            touched={touched}
            touchedMessage="Are you sure that you want to leave? This building has unsaved changes.">
            <div>
              <div className="row">
                <div className="col-xs-12">
                  <Field
                    name="name"
                    value={building.name}
                    onChange={this.handleChange}
                    label="Building Name"
                    disabled={fetching}
                  />
                </div>
              </div>
              {/* <div className='row'>
                <div className='col-xs-12'>
                  <FieldLocation
                    addressName='address'
                    geoName='geo.coordinates'
                    value={building.address}
                    onChange={this.handleChange}
                    label='Building Location'
                    disabled={fetching}
                  />
                </div>
              </div> */}

              <InstructionsContainer>{pointInstructions}</InstructionsContainer>
            </div>
          </Panel>
        </PanelContainer>
        <MapPortal center={building.geo.coordinates}>
          <MapEditPoint
            center={building.geo.coordinates}
            onMarkerLocationChange={coords =>
              this.handleChange({
                name: "geo.coordinates",
                value: coords
              })
            }
          />
        </MapPortal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Facility/EditBuilding/index.jsx